<template>
  <footer class="py-3 footer">
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
